import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AnalyticsService } from '~app/shared/services/analytics/analytics.service';
import { environment } from '~env';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  constructor(private readonly router: Router, private readonly analytics: AnalyticsService) {}

  public ngOnInit(): void {
    if (environment.featureFlags.analytics) this.analytics.start();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }
}
